export default __webpack_public_path__ + "static/media/phone.dcb86183.png";